module.exports = __webpack_public_path__ + "media/assets/images/category/Thanks@2x-e0e352cdb11d4441cb2955b74b759df4.png";